import { RightOutlined } from '@ant-design/icons';

import * as St from './NextStepButton.styles';

import { StepName } from '~/core/enums';
import { useNavigationContext } from '~/legacy/easy-estimator-page/context/navigationContext';

const NextStepButton = () => {
  const { nextStep, enabledSteps, goToNextStep } = useNavigationContext();
  const isNextStepEnabled = enabledSteps.includes(nextStep);

  return (
    <St.Container
      onClick={!isNextStepEnabled ? undefined : goToNextStep}
      disabled={!isNextStepEnabled}
    >
      {text[nextStep]} <RightOutlined />
    </St.Container>
  );
};

export default NextStepButton;

// TODO: use translation.json
const text: { [Key in StepName]: string } = {
  [StepName.store]: 'Store',
  [StepName.material]: 'Material',
  [StepName.color]: 'Color',
  [StepName.designShape]: 'Design',
  [StepName.designEdge]: 'Edge',
  [StepName.designCornerRadius]: 'Corner Radius',
  [StepName.designDiagonalCorner]: 'Diagonal Corner',
  [StepName.designCustomSide]: 'Custom Side',
  [StepName.designSink]: 'Sinks',
  [StepName.designCookingAppliance]: 'Cooking Appliance',
  [StepName.designCutout]: 'Cutouts',
  [StepName.designTearOut]: 'Tear-Out',
  [StepName.designAddOn]: 'Add On Options',
  [StepName.designPlumbing]: 'Plumbing',
  [StepName.orderSummary]: 'Order Summary',
};
